import { css } from '@emotion/react'
import { Sizes } from '../../../../style_helpers'

const styles = css`
  font-size: ${Sizes(-3)};
`

export default styles
